import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Insertion from "@vueEntry/Insertion.vue";
import { defineComponent } from "vue";
import { getSimilarRealEstateByREString } from "@services/realEstateAPI";
export default defineComponent({
  name: "SimilarREScrolling",
  components: {
    Insertion
  },
  props: {
    realEstate: {
      type: Object,
      required: true
    },
    similarListingUrl: {
      type: String,
      required: true
    },
    isFavourites: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  emits: ["is-similar-re-empty"],
  data() {
    return {
      realEstateList: [],
      loading: true
    };
  },
  computed: {
    loadingLabel() {
      //@ts-ignore
      return window["_loadingLabel"];
    },
    viewAllLabel() {
      //@ts-ignore
      return window["_viewAllLabel"];
    }
  },
  mounted() {
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          if (this.realEstateList.length < this.getLimit()) {
            getSimilarRealEstateByREString(this.realEstate, this.realEstateList.length).then(response => {
              if (!response.length) {
                this.$emit("is-similar-re-empty", true);
                this.loading = false;
              } else {
                this.$emit("is-similar-re-empty", false);
                this.realEstateList.push(...response);
                observer.observe(entry.target);
              }
            });
          } else {
            this.loading = false;
          }
        }
      });
    }, {
      threshold: 1
    });
    var loadingElement = document.getElementById("infinite-scrolling-loading");
    observer.observe(loadingElement);
  },
  methods: {
    getLimit() {
      return window["infiniteScrolling"] || 4;
    }
  }
});